import m from "mithril";
export const Navigation = {
    mainNavigationItems: [
        { title: 'Chat', href: 'https://web.libera.chat/gamja/#konsumi' },
        { title: 'Code', href: 'https://codeberg.org/konsumi' },
        { title: 'Documentation', href: 'https://docs.konsumi.rocks/' }
    ],
}